// RadioButton.js
import React from "react";
import radioButtoncss from "../css/radioButton.module.css"


export default function RadioButton({ label, name, value, checked, onChange }) {
  return (
    <label className={radioButtoncss.radioLabel}>
      <input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        className={radioButtoncss.radioInput}
      />
      <span className={radioButtoncss.customRadio}></span>
      {label}
    </label>
  );
}
